import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/scheduled-emails")({
  beforeLoad: () => {
    throw redirect({ to: "/prospects", replace: true });
  },
});
